module.exports = __webpack_public_path__ + "media/fail.dea3580b.mp3";